module.exports = __webpack_public_path__ + "static/img/floatLeftImg3.249e317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floatLeftImg3.png
// module id = FAyR
// module chunks = 2